import { render, staticRenderFns } from "./CxAssetsTable.vue?vue&type=template&id=0449fbee&scoped=true&"
import script from "./CxAssetsTable.vue?vue&type=script&lang=js&"
export * from "./CxAssetsTable.vue?vue&type=script&lang=js&"
import style0 from "./CxAssetsTable.vue?vue&type=style&index=0&id=0449fbee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0449fbee",
  null
  
)

export default component.exports